import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

import { requestSelectors } from 'src/store/requests/selectors';
import { Actions } from 'src/store/spinner/actions';
import { ISpinnerDataPossibilityInnerData } from 'src/typings/spinner';

export const useGetFloorsSpinner = (
  idFloor: string[],
) => {
  const dispatch = useDispatch();
  const spinnerData = useSelector(requestSelectors.spinner.getSpinnerData);
  const [spinnerFloor, setSpinnerFloor] = useState<ISpinnerDataPossibilityInnerData | undefined>(undefined);

  useEffect(() => {
    for (let i = 0; i < idFloor.length; i += 1) {
      const floor = spinnerData?.spinners?.floor?.[idFloor[i]];
      if (floor) {
        setSpinnerFloor(floor);
        dispatch(Actions.setAppCurrentSpinner({ name: 'floor', 'name-id': idFloor[i] }));
        break;
      }
    }
  }, [idFloor, spinnerData]);

  return {
    spinnerFloor,
  };
};
